import { Column } from 'ag-grid-community';
import { parseFilterModel } from 'components/Blotters/Filter/Badges/hooks';

export function serverSideSanitizeFilterModel(
  _columns: readonly Column[],
  currentColumnsFilterState: Record<string, unknown>,
) {
  const sanitized = Object.fromEntries(
    Object.entries(currentColumnsFilterState)
      .filter(([_, value]) => value !== undefined)
      .map(([key, value]) => [key, parseFilterModel(value)]),
  );
  return sanitized;
}
